<template>
  <div>
    <contadores
      :total="qtdFormularios.total"
      :ativos="qtdFormularios.ativos"
      :inativos="qtdFormularios.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <formulario-add-new
      :is-info-dialog-open.sync="isInfoDialogOpen"
    />

    <v-card>
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          outlined
          hide-details
          dense
          class="user-search me-3 mb-4"
          @keyup="getData"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            title
            color="success"
            class="mb-4 px-4"
            @click.stop="isInfoDialogOpen = !isInfoDialogOpen"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar Formulário</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <table-formulario
          :items="formularios"
          :headers="headers"
          @confirmar-ativacao-inativacao="getData"
          @refetch-data="getData"
        />
      </v-col>
    </v-card>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api'
import { mdiPlus } from '@mdi/js'
import Contadores from '@/views/formulario/Contadores.vue'
import TableFormulario from '@/components/tables/TableFormulario.vue'
import FormularioAddNew from '@/views/formulario/FormularioAddNew.vue'
import FormularioService from '@/services/modules/FormularioService'

export default {
  components: {
    TableFormulario,
    Contadores,
    FormularioAddNew,
  },

  setup() {
    const isInfoDialogOpen = ref(false)

    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'DESCRIÇÃO', value: 'descricao' },
      { text: 'STATUS', value: 'ativo' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    const isAddNewFormularioSidebarActive = ref(false)
    const formularios = ref([])
    const loading = ref(true)
    const search = ref('')
    const filtros = ref('')
    const itensPagina = ref('')
    const qtdFormularios = reactive({
      total: 0,
      ativos: 0,
      inativos: 0,
    })

    async function getFormularios(itensPorPagina) {
      itensPagina.value = itensPorPagina

      try {
        const data = await FormularioService.get(itensPorPagina, filtros.value, search.value)

        formularios.value = data.sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))

        setTimeout(() => {
          loading.value = false
        }, 1000)
      } catch {
        loading.value = false
      }
    }

    function atualizarFiltro(item) {
      filtros.value = item
      getFormularios(itensPagina.value)
    }

    async function getEstatisticas() {
      const data = await FormularioService.getFormulariosEstatisticas()

      Object.assign(qtdFormularios, {
        total: data.total,
        ativos: data.ativas,
        inativos: data.inativas,
      })
    }

    async function getData() {
      await getEstatisticas()
      getFormularios(qtdFormularios.total)
    }

    onMounted(getData)

    return {
      isInfoDialogOpen,
      isAddNewFormularioSidebarActive,
      formularios,
      loading,
      search,
      filtros,
      qtdFormularios,
      itensPagina,
      atualizarFiltro,
      getData,
      headers,
      icons: {
        mdiPlus,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
